/** A catalog image as returned by the backend — paths are relative to the API base. */
export type CatalogImage = {
  id: string;
  thumb_path: string;
  full_path: string;
};

export type CatalogImageOwnerType = 'MENU_ITEM' | 'DINING_OFFERING' | 'VENDOR_SERVICE' | 'WALK_REPORT' | 'WALK_INCIDENT' | 'TRAINING_REPORT' | 'CREMATION_FULFILLMENT' | 'LAB_REPORT' | 'PHARMACY_PRODUCT' | 'FOOD_PRODUCT' | 'GROOMING_REPORT_BEFORE' | 'GROOMING_REPORT_AFTER';

export const MAX_IMAGES_PER_OWNER = 5;
